// extracted by mini-css-extract-plugin
export default {"BankIdContainer":"_BankIdContainer--AaecU","ContinueButton":"_ContinueButton--rVD42","Loading":"_Loading--_tbEs"};